import * as React from "react"

import { Row, Col, Container } from "shards-react"

import NavigationList from "./navigationList"
import NavigationLink from "./navigationLink"
import MailingList from "./mailingList"

import articles from "../data/supportArticles.json"

const MiddleFooter = props => (
  <div className="bg-dark text-light pb-5">
    <Container>
      <br />
      <Row>
        <Col xs={12} sm={12} md={3}>
          <br />
          <h5 className="text-light">Help & Support</h5>
          <NavigationList>
            {articles.map(article => (
              <NavigationLink
                key={article.id}
                light
                external
                key={article.id}
                slug=""
                title={article.title}
                href={article.href}
              />
            ))}
          </NavigationList>
          <br />
        </Col>
        <Col xs={12} sm={12} md={3}>
          <br />
          <h5 className="text-light">Legal</h5>
          <NavigationList>
            <NavigationLink
              light
              countryCode={props.countryCode}
              title="Terms of Use"
              href={props.routes.terms}
            />
            <NavigationLink
              light
              countryCode={props.countryCode}
              title="Student Agreement"
              href={props.routes.studentAgreement}
            />
            <NavigationLink
              countryCode={props.countryCode}
              light
              title="Refund Policy"
              href={props.routes.refundPolicy}
            />
          </NavigationList>
          <br />
        </Col>
        <Col xs={12} sm={12} md={6}>
          <MailingList />
        </Col>
      </Row>
    </Container>
  </div>
)

export default MiddleFooter
